import { useEffect, useState } from 'react';
import { Dialog } from './ui/Dialog';
import { Button } from './ui/Button';
import { Input } from './ui/Input';

/**
 * Diálogo de confirmación destructiva con doble seguro: el botón de confirmar
 * permanece deshabilitado hasta que el usuario escribe exactamente la palabra
 * `palabraConfirmacion` (por defecto "ELIMINAR", en mayúsculas).
 *
 * Props:
 *  - open, onClose, onConfirm (async)
 *  - titulo, descripcion
 *  - palabraConfirmacion (default "ELIMINAR")
 *  - textoBotonConfirmar (default "Eliminar")
 */
export default function ConfirmacionEliminar({
  open,
  onClose,
  onConfirm,
  titulo = 'Eliminar',
  descripcion = '',
  palabraConfirmacion = 'ELIMINAR',
  textoBotonConfirmar = 'Eliminar',
}) {
  const [texto, setTexto] = useState('');
  const [procesando, setProcesando] = useState(false);

  useEffect(() => {
    if (open) { setTexto(''); setProcesando(false); }
  }, [open]);

  const coincide = texto === palabraConfirmacion;

  const confirmar = async () => {
    if (!coincide || procesando) return;
    setProcesando(true);
    try {
      await onConfirm();
    } finally {
      setProcesando(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={titulo}
      description={descripcion}
      footer={
        <>
          <Button variant="outline" onClick={onClose} disabled={procesando}>Cancelar</Button>
          <Button variant="danger" onClick={confirmar} disabled={!coincide || procesando}>
            {procesando ? 'Eliminando…' : textoBotonConfirmar}
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        <p className="text-sm text-slate-600">
          Para confirmar, escribe <span className="font-semibold text-slate-900">{palabraConfirmacion}</span> en el campo:
        </p>
        <Input
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          placeholder={palabraConfirmacion}
          autoFocus
          onKeyDown={(e) => { if (e.key === 'Enter') confirmar(); }}
        />
      </div>
    </Dialog>
  );
}
